import React, { useEffect, useId, useMemo } from "react";
// import { modal_ad } from "../../styles/modules/modal_palette.module.css";
import PlaceholderAd from "./PlaceholderAd";
import { ad_wrapper } from "./styles.module.css";

function AdWithPlaceholder({ ins = "" }) {
  // const [renderAd, setRenderAd] = React.useState(false);
  const [renderPlaceholder, setRenderPlaceholder] = React.useState(true);
  const instanceId = useId();
  const adContainerId = useMemo(
    () => `adWithPlaceholder-${instanceId.replace(/[:]/g, "")}`,
    [instanceId]
  );

  useEffect(() => {
    const hasConsent = (() => {
      try {
        const storedConsent = window.localStorage.getItem("cookiesConsent");
        return storedConsent === null ? true : storedConsent === "true";
      } catch (error) {
        return true;
      }
    })();

    if (!hasConsent) {
      setRenderPlaceholder(false);
      return;
    }

    setTimeout(() => {
      setRenderPlaceholder(false);
      let adsbygoogle;
      if (document.getElementById(adContainerId)) {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }
    }, 1500);
  }, [adContainerId]);

  return (
    <div className={ad_wrapper}>
      <div id={adContainerId} dangerouslySetInnerHTML={{ __html: ins }}></div>
      {renderPlaceholder ? <PlaceholderAd /> : null}
    </div>
  );
}

export default AdWithPlaceholder;
